import { apiReady as eventsApiReady } from './apiReady.tsx';
import { legacyIssueCreateCombinedInteraction } from './legacyIssueCreateCombinedInteraction.tsx';
import { legacyIssueCreateInitialRenderInteraction } from './legacyIssueCreateInitialRenderInteraction.tsx';
import { legacyIssueCreateTransitionInteraction } from './legacyIssueCreateTransitionInteraction.tsx';
import type { TriggerSource } from './TriggerSource.types.tsx';

export const sendEndMarkForLegacyIssueCreate = async ({
	isInitialLoad,
	triggerSource,
}: {
	isInitialLoad?: boolean;
	triggerSource?: TriggerSource;
}): Promise<void> => {
	const Events = await eventsApiReady();
	const onCreateIssueDialogRendered = () => {
		if (typeof isInitialLoad === 'boolean') {
			if (isInitialLoad) {
				legacyIssueCreateInitialRenderInteraction.stop({
					customData: {
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
						triggerSource,
						isGICPrefetchEnabled: true,
					},
				});
			} else {
				legacyIssueCreateTransitionInteraction.stop({
					customData: {
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
						triggerSource,
						isGICPrefetchEnabled: true,
					},
				});
			}
			legacyIssueCreateCombinedInteraction.stop({
				customData: {
					// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
					triggerSource,
					isGICPrefetchEnabled: true,
				},
			});
		}
		Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
	};

	Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};
